import DOMPurify from 'dompurify';
import { FaRegCircle } from 'react-icons/fa6';
import React, { useRef, useState } from 'react';
import { BsExclamationDiamond } from 'react-icons/bs';

const ProcessInfoModal = ({ procedure }) => {
  const contentRef = useRef([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const styleImages = htmlContent => {
    const doc = new DOMParser()?.parseFromString(htmlContent, 'text/html');
    const images = doc?.querySelectorAll('img');

    images.forEach(img => {
      img.style.width = '80px';
      img.style.height = 'auto';
    });

    return doc.body.innerHTML;
  };

  const numberOfSteps = procedure?.proc?.length || 0;
  const stepHeight = 60;
  const totalHeight = (numberOfSteps + 1) * stepHeight + 40;

  const handleStepClick = index => {
    setSelectedIndex(index);
  };

  const handleFlowchartClick = index => {
    setSelectedIndex(index);
  };

  const sanitizedSafetyNoteInfo = DOMPurify.sanitize(
    procedure?.procedureSafetyNote?.procedureNoteInfo || ''
  );
  const styledsafetyNoteInfo = styleImages(sanitizedSafetyNoteInfo);

  return (
    <div className="p-6 ">
      <h2 className="text-1xl font-bold mb-4">Safety Notes</h2>

      <div key={'1'} className={`cursor-pointer p-2 rounded-tl-md ${''}`}>
        <h3
          className={`text-2xl font-semibold mb-2 flex flex-row ${'text-blue-500'}`}
        >
          <span
            className={`h-[30px] w-[30px] rounded-[50%] flex justify-center font-10 items-center mr-2 ${'bg-black text-white'}`}
          >
            {'S'}
          </span>
          {procedure?.procedureSafetyNote?.title ?? 'Untitled Safety Note'}
        </h3>
        <p
          // className="text-gray-700 mb-4"
          dangerouslySetInnerHTML={{ __html: styledsafetyNoteInfo }}
        />
        <hr className="border-t-2 border-gray-300" />
      </div>

      <div className="flex flex-row items-center">
        {/* steps info-- */}

        <div className="w-2/3">
          <section id="process-steps">
            <div className="space-y-8">
              {procedure?.proc?.map((item, index) => {
                const sanitizedStepInfo = DOMPurify.sanitize(
                  item?.steps?.stepInfo || ''
                );
                const sanitizedDecisionInfo = DOMPurify.sanitize(
                  item?.decisions?.decisionInfo || ''
                );

                // styles to images
                const styledStepInfo = styleImages(sanitizedStepInfo);
                const styledDecisionInfo = styleImages(sanitizedDecisionInfo);

                const isSelected = index === selectedIndex;

                return item?.steps ? (
                  <div
                    key={index}
                    ref={el => (contentRef.current[index] = el)}
                    onClick={() => handleStepClick(index)}
                    className={`cursor-pointer p-2 rounded-tl-md ${
                      isSelected ? 'bg-gray-200 border border-gray-300' : ''
                    }`}
                  >
                    <h3
                      className={`text-2xl font-semibold mb-2 flex flex-row ${
                        isSelected ? 'text-blue-500' : ''
                      }`}
                    >
                      <span
                        className={`h-[30px] w-[30px] rounded-[50%] flex justify-center items-center mr-2 ${
                          isSelected
                            ? 'bg-blue-500 text-white'
                            : 'bg-black text-white'
                        }`}
                      >
                        {index + 1}
                      </span>
                      {item?.steps?.title || 'Untitled Step'}
                    </h3>
                    <p
                      className="text-gray-700 mb-4"
                      dangerouslySetInnerHTML={{ __html: styledStepInfo }}
                    />
                    <hr className="border-t-2 border-gray-300" />
                  </div>
                ) : (
                  <div
                    key={index}
                    ref={el => (contentRef.current[index] = el)}
                    onClick={() => handleStepClick(index)}
                    className={`cursor-pointer p-2 rounded-tl-md ${
                      isSelected ? 'bg-gray-200 border border-gray-300' : ''
                    }`}
                  >
                    <h3
                      className={`text-2xl font-semibold mb-2 flex flex-row ${
                        isSelected ? 'text-blue-500' : ''
                      }`}
                    >
                      <label className="flex mr-2">
                        <span className="pt-3"> {index + 1}</span>
                        <BsExclamationDiamond size={30} />
                      </label>
                      {item?.decisions?.title || 'Untitled Decision'}
                    </h3>
                    <p
                      className="text-gray-700 mb-4"
                      dangerouslySetInnerHTML={{ __html: styledDecisionInfo }}
                    />
                    <hr className="border-t-2 border-gray-300" />

                    <h3 className="text-md font-semibold mb-2 mt-2">
                      <label>ANSWERS</label>
                      <div className="h-[10vh] overflow-y-auto">
                        {item?.decisions?.answer?.map((answer, idx) => (
                          <div
                            className="w-full mt-2 flex justify-between items-center border border-b-slate-300 p-2"
                            key={idx}
                          >
                            <div className="flex flex-row items-center justify-center">
                              <FaRegCircle
                                style={{
                                  color: 'grey',
                                  marginTop: '3px',
                                  marginRight: '3px',
                                }}
                                size={10}
                              />
                              <h2 className="ml-2">{answer?._ans}</h2>
                            </div>

                            <div>
                              {answer?.type === 'steps' ? (
                                <span className="h-[20px] w-[20px] bg-black rounded-full text-white flex justify-center items-center">
                                  {index + 1}
                                </span>
                              ) : (
                                <label className="flex items-center space-x-1">
                                  {index + 1}
                                  <BsExclamationDiamond size={20} />
                                </label>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </h3>
                  </div>
                );
              })}
            </div>
          </section>
        </div>

        {/* // flow chart */}

        <div className="w-1/3">
          <div className="relative flex flex-col items-center">
            {/* Flowchart Container */}
            <div className="relative mb-8">
              {/* Steps and Connectors */}
              <div className="relative flex flex-col items-center z-10">
                {/* Start Circle */}
                {numberOfSteps ? (
                  <div
                    className={`bg-blue-500 text-white rounded-full w-14 h-14 flex items-center justify-center mb-4 z-10 ${
                      selectedIndex === 0 ? 'border-4 border-yellow-400' : ''
                    }`}
                    onClick={() => handleFlowchartClick(0)}
                  >
                    Start
                  </div>
                ) : null}

                {/* Steps and Decisions */}
                {procedure?.proc?.map((item, index) => (
                  <a
                    className="text-sm mt-1"
                    href={`#${item?.decisions?.title || item?.steps?.title}`}
                  >
                    {' '}
                    <div
                      key={`step-${index}`}
                      className={`rounded-lg w-48 text-center h-14 flex flex-col items-center justify-center mb-4 z-10 cursor-pointer
              ${
                item?.steps?.title
                  ? 'bg-green-100 border border-green-500 text-green-700' // Style for "Step"
                  : 'bg-yellow-100 border border-yellow-500 text-yellow-700' // Style for "Decision"
              }
              ${selectedIndex === index ? 'ring-2 ring-blue-700' : ''}
            `}
                      onClick={() => handleFlowchartClick(index)}
                    >
                      <span className="text-sm font-semibold">
                        {item?.steps?.title ? 'Step' : 'Decision'}
                      </span>
                      <span className="text-sm mt-1">
                        {item?.steps?.title?.length > 20
                          ? item.steps.title.substring(0, 20) + '...'
                          : item?.steps?.title ||
                            (item?.decisions?.title?.length > 20
                              ? item.decisions.title.substring(0, 20) + '...'
                              : item?.decisions?.title) ||
                            'Untitled'}
                      </span>
                    </div>
                  </a>
                ))}

                {/* End Circle */}
                {numberOfSteps ? (
                  <a
                    className="text-sm mt-1"
                    href={`#${procedure?.endProcedure?.title}`}
                  >
                    {' '}
                    <div
                      key={`step-${numberOfSteps}`}
                      className={`bg-red-100 border border-red-500 rounded-lg w-40 h-14 flex text-center flex-col items-center justify-center mb-4 z-10 cursor-pointer ${
                        selectedIndex === numberOfSteps
                          ? 'ring-2 ring-blue-700'
                          : ''
                      }`}
                      onClick={() => handleFlowchartClick(numberOfSteps)}
                    >
                      <span className="text-sm font-semibold">End Step</span>
                      <span className="text-sm mt-1">
                        {procedure?.endProcedure?.title || 'Untitled End Step'}
                      </span>
                    </div>
                  </a>
                ) : null}
              </div>

              {/* Vertical Line Connecting All Items */}
              <div className="absolute inset-0 flex flex-col items-center z-0">
                <div
                  className="border-l-2 border-blue-500 w-0 absolute"
                  style={{
                    top: 0,
                    height: procedure?.endProcedure?.title
                      ? (procedure?.proc?.length + 1) * stepHeight +
                        procedure?.proc?.length * 18
                      : procedure?.proc?.length * stepHeight +
                        procedure?.proc?.length * 18, // Total height for all steps and spacing
                    left: '50%',
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessInfoModal;
